/** The table's status cell: the pill, when it changes, and the "opens" chevron. */
import { campaignRelativeText } from '@bonsai/shared';
import { ChevronRight } from 'lucide-react';

import type { CampaignListRow } from '../ticket-sales-campaigns-list-model';
import TicketSalesCampaignStatusPill from '../TicketSalesCampaignStatusPill';

export interface TicketSalesCampaignStatusCellProps {
  row: CampaignListRow;
  now: Date;
  showChevron: boolean;
}

export function TicketSalesCampaignStatusCell({
  row,
  now,
  showChevron,
}: TicketSalesCampaignStatusCellProps) {
  return (
    <td style={{ paddingRight: 18 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{ flex: 1 }}>
          <TicketSalesCampaignStatusPill status={row.status} />
          <div
            style={{
              fontSize: 11.5,
              color: 'var(--nb-subtle)',
              marginTop: 4,
              whiteSpace: 'nowrap',
            }}
          >
            {campaignRelativeText(row.campaign, now)}
          </div>
        </div>
        {showChevron && (
          <ChevronRight
            size={14}
            aria-hidden
            style={{ color: 'var(--nb-faint)', flex: '0 0 auto' }}
          />
        )}
      </div>
    </td>
  );
}
